import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import { tracked } from '@glimmer/tracking';
import PledgeModel from 'donor-elf-web/models/pledge';
import LoadingSpinner from 'donor-elf-web/components/loading-spinner';
import lifecycle from 'donor-elf-web/modifiers/lifecycle';
import formatDate from 'donor-elf-web/helpers/format-date';
import formatAmount from 'donor-elf-web/helpers/format-amount';
import toLowerCase from 'donor-elf-web/helpers/to-lower-case';

export default class EventInfoNewPledgeComponent extends Component<EventInfoComponentArgs> {
  @service declare store: Store;

  @tracked pledge?: PledgeModel;

  onLifecycle = async () => {
    this.pledge = await this.store.findRecord(
      'pledge',
      this.args.eventModel.pledgeId!,
    );
  }

  <template>
    <div {{lifecycle this.onLifecycle}}>
      {{#if this.pledge}}
        They started a
        {{formatAmount this.pledge.amount removeNoCents=true}}
        {{toLowerCase this.pledge.frequencyLabel}}
        pledge on
        {{formatDate this.pledge.startDate}}.
      {{else}}
        <LoadingSpinner />
      {{/if}}
    </div>
  </template>
}
